import { builtinV1 } from '../../builtin'

// klinecharts 9.8.12 built-in 'BOLL' (dist/index.esm.js), untouched: version 1 for existing instances only.
export default builtinV1({ id: 'BOLL', label: 'Bollinger Bands', pane: 'main', params: [20, 2], outputs: ['up', 'mid', 'dn'], labels: ['Length', 'StdDev'], kinds: ['int', 'float'] })
